import { Select, Space } from 'antd';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { BooleanSelectFilter } from '../../components/BooleanSelectFilter';

const ROLE_OPTIONS = [
  { label: 'Адмін', value: 'admin' },
  { label: 'Користувач', value: 'user' },
];

const AUTH_OPTIONS = [
  { label: 'Пароль', value: 'true' },
  { label: 'Google', value: 'false' },
];

export const UserFilters: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const roleValue = searchParams.get('role') ?? undefined;
  const hasPasswordValue = searchParams.get('hasPassword') ?? undefined;

  const handleChange = (name: string) => (value: string | undefined) => {
    setSearchParams((prev) => {
      if (value !== undefined) prev.set(name, value);
      else prev.delete(name);
      return prev;
    });
  };

  return (
    <Space wrap>
      <Select
        placeholder="Роль"
        allowClear
        style={{ width: 140 }}
        value={roleValue}
        onChange={handleChange('role')}
        options={ROLE_OPTIONS}
      />
      <Select
        placeholder="Вхід"
        allowClear
        style={{ width: 120 }}
        value={hasPasswordValue}
        onChange={handleChange('hasPassword')}
        options={AUTH_OPTIONS}
      />
      <BooleanSelectFilter name="marketingOptIn" placeholder="Розсилка" />
    </Space>
  );
};
